<template>
    <div id="batchSection" class="app-inner">
          <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="reback">
            返回
            </div>
           <el-button type="primary"  :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
            @click="openSub('ruleForm')"
            >
             保存
           </el-button>
            </div>
               <div class="edit-from">
                  <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules" class="flex">
                 <div class="public-tit flex align-cen">
                    <div class="public-tit-list">
                        <i class="icon-al-database-fill"></i>  基本信息
                    </div>
                </div>
                     <el-form-item label="关联章节：" prop="parentId">
                 <el-select
                        v-model="form.parentId"
                        clearable
                        placeholder="请选择关联章节"
                    >
                        <el-option
                        v-for="item in list"
                          :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
            </el-option>
          </el-select>
         </el-form-item>
         <!-- <el-form-item label="设置试听课：">
                    <el-radio v-model="form.trial" label="0">否</el-radio>
                    <el-radio v-model="form.trial" label="1">是</el-radio>
                </el-form-item> -->
                  </el-form>
         </div>
          <div class="public-tit flex align-cen" ref="document" style="margin-top:20px">
                      <div class="public-tit-list">
                          <i class="icon-al-application"></i> 课程文件
                      </div>
             <div class="mft public-btn-small flex align-cen" ref="materials" style="margin-right:20px">
                     <div class="public-btn-small-primary" v-if="isShow == 2" @click="isShow = 1">
                          手动上传         
                    </div>
                </div>
                     <div class="public-btn-small" style="padding-left:0">
                     <div class="public-btn-small-primary" @click="openTeam">
                          素材库上传         
                    </div>
                </div>
              </div>
                 <div class="importTopic" v-if="isShow == 1">
            <el-upload 
            accept="" drag   
            :auto-upload="true" 
             :action="$config.baseUrl + '/admin/sys-file/upload'" 
              :headers="headers"
             :on-success="handleSuccess"
             :on-remove="handleRemove"
             :file-list="fileList"
             multiple
              ref="upload"  
              >
                <i class="icon-al-file-fill"></i>
                <div class="el-upload__text">
                   课程文件拖拽到此区域上传，或<em>选择文件上传</em>
                </div>
               <el-button size="small" type="primary">选择文件</el-button>
            </el-upload>
            <div class="tips-text">
                <div class="title">上传说明</div>
                <p style="margin-top:17px">
                支持视频、音频、文档、图片批量上传
                </p>
            </div>
        </div>
               <!-- 人员 -->
        <div class="team-tab" v-if="isShow == 2">
                <el-table
            :data="relationList"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
             <el-table-column label="文件名称" align="center" prop="fileName">
         </el-table-column>
           <el-table-column prop="fileSize" label="大小" align="center">
             <template slot-scope="scope">
                <div>
                    {{scope.row.fileSize | kbToMb}}
                </div>
             </template>
         </el-table-column>
          <el-table-column  label="文件类型" align="center" prop="type">
          </el-table-column>
               <el-table-column
            fixed="right"
            label="操作"
            align="center"
            >
             <template slot-scope="scope">
            <el-button type="text" size="small" style="color:red" @click="deletPro(scope.row)">取消选择</el-button>
             </template>
             </el-table-column>
         </el-table>
        </div>
          <el-dialog
  title="选择素材"
  :visible.sync="centerDialogVisible"
  width="80%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible"
   @close="reback1"
  >
         <div class="forminfo"> 
    <teamTemplate
     :temParms="'materialLibrary'"
     @sendStatus="classSelect"
    ref="teamTem"
    ></teamTemplate>
       <div class="authbtn flex align-cen">
             <el-button plain @click="reback1">取消</el-button>
              <el-button type="primary"  @click="onSubmit1">确认选择</el-button>
        </div>
  </div>
          </el-dialog>
    </div>
</template>
<script>
import {courseChapterList,courseChapter} from "@/api/enterprise/index"  //章节列表、批量新增章节
import teamTemplate from "@/weteacheManage/enCourse/enMaterialLibrary/index.vue"; //将素材库页面作为组件使用
export default {
     components:{
        teamTemplate,
    },
    data () {
        return {
            isShow:1,
            relationList:[],
            selectList:[],
            centerDialogVisible:false,
            fileList:[],
            headers:{},
            loading:false,
            list:[],
            form:{
                courseId:'',
                parentId:'',
                materialList:[]
            },
             rules:{
              parentId: [{ required: true, message: '请选择关联章节', trigger: 'change' }],
            }
        }
    },
    created() {
        this.chapterList()
        this.form.courseId = this.$route.query.id
     let token = this.$locaStorage.setAge().get('token1')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
    },
    methods: {
        // 保存批量新增章节
         openSub(formName){
              let safeA = [],
                safeB = []
            if(this.relationList.length){
                safeA = this.relationList.map(({ id, fileName, fileSize, type, url, fileId }) => ({
                    materialId: id,
                    fileName,
                    fileSize,
                    type,
                    url,
                    fileId
                }))
            }
             if(this.fileList.length){
              safeB = this.fileList.map(({ response: { data } }) => ({
                materialId: '',
                fileName: data.fileName,
                fileSize: data.fileSize,
                type: data.type,    
                url: data.url,
                fileId: data.fileId
            }))
            }
             this.form.materialList = [...safeA,...safeB]
            if(this.form.materialList.length == 0) return this.$util.Notifi('请上传课程文件或从素材库中选择上传','error','fa-exclamation-circle');
            this.$refs[formName].validate((valid) => {  
                     if(valid){
                        this.loading = true
                 courseChapter(this.form)
                    .then(res => {
                        if(res.code == 0){
                        this.loading = false
                       this.$message.success('批量新增成功');
                     setTimeout(() => {
                            this.$router.push({
                                name: "enTwoCourse",
                                query:{
                                    twoId:this.$route.query.id,
                                }
                            })
                            }, 100);
                        }else{
                            this.loading = false
                        this.$message.error(res.msg)
                        }
                    })
                    .catch(err => {
                        this.loading = false
                    })
                     }
              })
         },
           // 取消选择
        deletPro(data){
                let arr = []
                arr.push(data)
             let delet= this.relationList.filter(item=>!arr.some(ele=>ele.id===item.id))
            this.relationList = delet
        },
         // 打开选择窗口
        openTeam(){
            let that = this
             this.centerDialogVisible = true  
             this.isShow = 2
                   this.$nextTick(function () {   
                 that.$refs.teamTem.editfun(that.relationList)    
             })
        },
       // 确认选择
        onSubmit1(){
           this.relationList = this.selectList
           this.centerDialogVisible = false
        },
         classSelect(val,val1){
           this.selectList = val
        },  
               // 文件上传成功
        handleSuccess(res, file,fileList){
           this.fileList = fileList
        },
          handleRemove(file, fileList){
       this.fileList = fileList
      },
                // 获取章节列表
        chapterList(){
              courseChapterList({
                id:this.$route.query.id
              })
            .then(res => {
                
                if(res.code == 0){
                  if(res.data !==null){
                    this.list = res.data
                  }else{
                    this.list = []
                  }
                }
            })
            .catch(err => {
            })
        },
        // 返回
        reback(){
        this.$router.push({
            name: "enTwoCourse",
            query:{
                twoId:this.$route.query.id,
            }
           })
        },
        // 取消素材选择
        reback1(){
              this.$refs['teamTem'].remove()  
             this.centerDialogVisible = false  
        },
    },
     filters: {
        kbToMb(value) {
            return (value / 1024 / 1024).toFixed(2) + ' MB'
        }
        }
}
</script>
<style lang="scss" scoped>
#batchSection{
    margin-bottom: 70px;
}
.importTopic{
    width: 100%;
    text-align: center;
    padding-top: 0px;
    box-sizing: border-box;
    .template-text{
        display: flex;
        align-items: center;
    justify-content: center;
    color: #7a8c99;
    font-size: 14px;
    cursor: pointer;
    padding-top: 20px;
.excel-icon{
        display: inline-block;
    width: 20px;
    height: 20px;
    background: url('../../../assets/images/excel-deactivate.svg') center no-repeat;
}
    }
    .tips-text{
   background-color: #f2f9fe;
    padding: 25px 10px 30px 30px;
    margin: 50px 35px 24px;
    text-align: left;
    .title{
        font-size: 18px;
        color: #36aafd;
    line-height: 30px;
    font-weight: normal;
    font-stretch: normal;
    }
    p{
        font-size: 16px;
        line-height: 30px;
    letter-spacing: 0px;
    color: #666666;
    }
    }
}
   .edit-from{
         margin-bottom: 44px;
         .public-tit{
            width: 100%;
            margin-bottom: 20px;
         }
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
           .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        .el-textarea{
            width: 80%;
        }
        
        }
         }
         .App-tab{
            margin: 20px 0;
            
        }
         }
           ::v-deep{
    .el-upload,.el-upload-dragger{
    background: none;
    border: none;
    height: auto;
   .icon-al-file-fill{
    font-size: 80px;
    color: #C0C4CC;
    margin: 0px 0 16px;
    }
    .el-button{
        margin-top: 30px;
    }
    }
 .el-dialog {
    margin-top: 5vh !important;
 }   
 .authbtn{
    margin-top: 30px;
    justify-content: center !important;
 }
}
</style>